import React from "react"
import { Spinner } from "reactstrap"

const IsLoading = () => {
  return <Spinner color="primary" className="d-block mx-auto mb-3" />
}

export default IsLoading
